const firebaseConfig = {
    apiKey: "AIzaSyBIlKIAZm5cbm1p7hmlx7YTIHncwss6tm8",
    authDomain: "doctors-portal-ap.firebaseapp.com",
    projectId: "doctors-portal-ap",
    storageBucket: "doctors-portal-ap.appspot.com",
    messagingSenderId: "653837295663",
    appId: "1:653837295663:web:085ee1b4b61580debf26da"
  };
  export default firebaseConfig;